import { SurveyStatus } from "./survey.types";

const { Draft, Review, Rejected } = SurveyStatus;

const canEditSurvey = (status: SurveyStatus) => {
  return [Draft, Rejected, Review].includes(status);
};

export { canEditSurvey };
